import jQuery from 'jquery';

// FAQ - accordion layout
$('.js-faq-question').click(function(e) {
    e.preventDefault();

    let $question = $(this);
    let $answer = $question.siblings( '.js-faq-answer' );

    $question.stop().toggleClass( 'is-open' );
    $answer.stop().slideToggle();
});